import React from 'react'
import { useTranslation } from 'react-i18next'

import SpreadSheet from '../../../../components/SpreadSheet'

import { KEYWORDS_TABLE } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from './styles'

const keywordsSpreadSheetColumnLabels = ['keywords', 'exclude keywords']
const errorRowsIndexes = []

const KeywordsSection = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { values, setFieldValue, touched, errors } = formik

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Keywords')}</h3>
      <p>{t('You can paste the list from another spreadsheet and we will automatically add enough rows.')}</p>
      <SpreadSheet
        name={KEYWORDS_TABLE}
        setFieldValue={setFieldValue}
        formikData={values[KEYWORDS_TABLE]}
        columnLabels={keywordsSpreadSheetColumnLabels}
        maxRows={500}
        className={classes.spreadSheet}
        tableClassName={classes.spreadSheetTable}
        error={touched[KEYWORDS_TABLE] && errors[KEYWORDS_TABLE]}
        errorRowsIndexes={errorRowsIndexes}
      />
    </section>
  )
}

export default KeywordsSection
